<template>
  <div class="lib__form__announcement lib__form__announcement--sent"
    v-if="fileNumber && (createAppointmentStatus === null || createAppointmentStatus === 'noError')">
    <h2 class="lib__text-success">
      <i class="far fa-check-circle"></i>
      {{ $t('smartMeter.confirmation.title') }}
    </h2>
    <p v-if="!workRequesterId">{{ $t('smartMeter.confirmation.needToCompleteCustomerData') }}</p>
    <p v-if="skipAppointment">{{ $t('confirmation.nextContact') }}</p>
    <p v-else data-cy="appointment-confirmation-message"
      v-html="$t('appointment.confirmation.appointment', [appointmentDate, appointmentPeriod])"></p>
    <p data-cy="send-confirmation-message" v-html="$t('appointment.confirmation.send', [fileNumber, email])"></p>
  </div>
  <div class="lib__form__announcement lib__form__announcement--sent" v-else>
    <h2 class="lib__text-danger">
      <i class="far fa-times-circle"></i>
      {{ errorTitle }}
    </h2>
    <i18n path="smartMeter.error.callBackLabel" scope="global" tag="p">
      <b>
        {{ $t('smartMeter.error.callBackLabelNewAppointment') }}
      </b>
    </i18n>
    <p data-cy="send-confirmation-message" v-html="$t('appointment.confirmation.send', [fileNumber, email])"></p>
  </div>
</template>

<script lang="ts">
import { Component, Prop } from 'vue-property-decorator'
import { AppointmentInfo, ContactInfo, CreateAppointmentStatus } from '@/models'
import { contactService } from '@/services'
import Step from '@/components/steps/Step'
import { State } from 'vuex-class'
import { dateService, timeService } from '@/services'

@Component({ name: 'send-confirmation' })
export default class SendConfirmation extends Step {
  //#region [Property]
  @Prop({ type: String, required: true }) public readonly title!: string
  @Prop({ type: Object, required: true }) public readonly contactInfo!: ContactInfo
  //#endregion

  //#region [Data]
  public email: string = ''
  @State('noAppointment', { namespace: 'smartMeterConnection' })
  public skipAppointment!: boolean
  @State('appointment', { namespace: 'smartMeterConnection/appointment' })
  public appointmentInfoState!: AppointmentInfo
  @State('status', { namespace: 'smartMeterConnection/appointment' })
  public createAppointmentStatus!: CreateAppointmentStatus | null
  @State('fileNumber', { namespace: 'smartMeterConnection/stakeholder' })
  public fileNumber!: string | null
  @State('workRequesterId', { namespace: 'smartMeterConnection/stakeholder' })
  public workRequesterId!: string | null
  @State('requestId', { namespace: 'smartMeterConnection' })
  public requestId!: string
  //#endregion

  //#region [Computed]
  private get appointmentDate(): string {
    return this.appointmentInfoState?.selectedSlot ? dateService.displayDateText(this.appointmentInfoState.selectedSlot!.startDate!) : ''
  }

  private get appointmentPeriod(): string {
    const fromTime = this.appointmentInfoState?.selectedSlot ? timeService.displayTime(this.appointmentInfoState.selectedSlot!.startDate!) : ''
    const toTime = this.appointmentInfoState?.selectedSlot ? timeService.displayTime(this.appointmentInfoState.selectedSlot!.endDate!) : ''
    return this.$t('appointment.confirmation.fromTo', [fromTime, toTime]).toString()
  }

  private get errorTitle(): string {
    if (this.createAppointmentStatus === CreateAppointmentStatus.ErrorDuringScheduling) {
      return this.$t('smartMeter.error.errorDuringSchedulingTitle').toString()
    }
    if (this.createAppointmentStatus === CreateAppointmentStatus.ErrorDuringGetAvailabilities || this.createAppointmentStatus === CreateAppointmentStatus.ErrorUnSpecified) {
      return this.$t('smartMeter.error.ErrorDuringGetAvailabilitiesTitle').toString()
    }
    return ''
  }
  //#endregion

  //#region [Watch]
  public onContactInfoChanged(value: ContactInfo) {
    this.email = contactService.getContactEmail(value)
  }
  //#endregion

  //#region [Method]
  public mounted() {
    this.onContactInfoChanged(this.contactInfo)

    this.$appInsights.trackEvent('WR_SMC_StepSendConfirmation_Validated', {
      Segment: 'WR_SMC',
      WebRef: this.requestId
    })
  }
  //#endregion
}
</script>